import './more_dropdown';
import './tabs';

import $ from 'jquery';

// Foundation powers the menu so init it.
$(document).on('ready', function () {
    $(document).foundation();
});
